import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';


if ($('.image-slider').length) {

	var imageSlider = new Swiper(".image-slider .swiper", {
		effect: "fade",
		fadeEffect: {
			crossFade: true
		},
		loop: true,
		speed: 500,
		autoplay: {
			delay: 4000,
		},

    });

	$('.image-slider .next').on('click', function() {
		imageSlider.slideNext(1500);
	});

	$('.image-slider .prev').on('click', function() {
		imageSlider.slidePrev(1500);
	});

}

